<template>
  <div>
    <div class="login-page">
      <!-- 背景图 -->
      <!-- <img class="login-page-bg" src="http://static.1ydt.com/image/bg.jpg" alt="登陆背景图" /> -->
      <div class="login-form-box">
        <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px"
          class="demo-ruleForm login-container">
          <div class="hdiv">
            <a href="http://jazpan.com">
              <img class="hdlogo" src="//static.jazpan.com/img/logo1.png" />
              <div class="tit">夹子盘登录</div>
            </a>
          </div>
          <el-form-item prop="account">
            <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="账号"></el-input>
          </el-form-item>
          <el-form-item prop="checkPass">
            <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="密码"></el-input>
          </el-form-item>
          <!-- <el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox> -->
          <el-form-item style="width:100%;">
            <el-button type="primary" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">登录
            </el-button>
            <!--<el-button @click.native.prevent="handleReset2">重置</el-button>-->
          </el-form-item>
          <el-form-item>
            <div class="login-link-box">
              <div>记住我
                <el-switch v-model="ruleForm2.remember"></el-switch>
                <!-- <a href="http://jazpan.com">立即注册</a> -->
              </div>
              <div><a href="http://jazpan.com">忘记密码</a></div>
            </div>
            <div class="login-wxlg" @click="$refs.wxLoginDlg.show()">
              <div><img src="//static.jazpan.com/img/weixinlg.png" /></div>
              <div>微信登录</div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <WxLoginDlg ref="wxLoginDlg" @submitOK="$router.push(redirect || '/')" />
  </div>
</template>

<script>
import WxLoginDlg from '@/components/WxLoginDlg'
import { setToken } from '@/common/js/storage';
//import NProgress from 'nprogress'
export default {
  components: { WxLoginDlg },
  data() {
    return {
      redirect: null,
      logining: false,
      ruleForm2: {
        account: '',
        checkPass: '',
        remember: false,
      },
      rules2: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          //{ validator: validaePass }
        ],
        checkPass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          //{ validator: validaePass2 }
        ]
      },
      checked: true
    };
  },
  mounted() {
    this.redirect = this.$route.query.redirect;
  },
  methods: {
    handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    handleSubmit2(ev) {
      var _this = this;
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          //_this.$router.replace('/table');
          this.logining = true;
          //NProgress.start();
          var loginParams = { name: this.ruleForm2.account, pass: this.ruleForm2.checkPass, remember: this.ruleForm2.remember };
          this.$post('/lg/login', loginParams).then(res => {
            this.logining = false;
            //NProgress.done();
            if (process.env.NODE_ENV !== 'production')
              setToken(res.data);
            console.log('redirect:', this.redirect);
            this.$router.push(this.redirect || '/');
          }).catch(err => {
            this.logining = false;
            this.$message({
              message: err.response ? err.response.data || '服务器错误' : '网络错误',
              type: 'error'
            });
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}

</script>

<style lang="scss" scoped>
.login-page {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #f2f2f2;

  .login-page-bg {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .login-form-box {
    position: fixed;
    top: 40%;
    left: 50%;
    margin-top: -160px;
    margin-left: -230px;
    width: 460px;
    height: 320px;
    padding: 15px;
  }

  .login-link-box {
    display: flex;
    justify-content: space-between;
  }

  .login-wxlg {
    cursor: pointer;
    text-align: center;

    img {
      width: 50px;
    }
  }
}

.login-container {
  /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
  -webkit-border-radius: 5px;
  border-radius: 5px;
  -moz-border-radius: 5px;
  background-clip: padding-box;
  margin: auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;

  .hdiv {
    text-align: center;
    height: 50px;
    width: 180px;
    margin: 0 auto 30px auto;

    a {
      font-size: 20px;
      font-weight: bold;
      color: #db8585;
      text-decoration: none;
      display: flex;
    }

    .tit {
      padding-top: 8px;
      margin-left: 10px;
    }

    .hdlogo {
      width: 50px;
      height: 35px;
      margin: 5px 0 0 10px;
    }
  }



  .remember {
    margin: 0px 0px 35px 0px;
  }
}
</style>


// WEBPACK FOOTER //
// Login.vue?076e5a77